<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="text-danger" v-if="!isTokenValid">
        For your security, this automated login link has expired after several days.<br />
        If you have not yet received a new link, <a class="text-success" href="mailto:hello@precisionhealthreports.com">click here</a> and we’ll send you a new link
      </div>
      <div class="page-form-content" v-if="isTokenValid">
        <horizontal-stepper class="custom-stepper"
                            ref="stepper"
                            :steps="steps">
        </horizontal-stepper>
      </div>
      <div class="page-form-footer" v-if="isTokenValid">
        <b-form-group class="form-buttons">
          <b-btn variant="success" @click="next" :disabled="profile.agreementAccepted === false">Save &amp; Continue</b-btn>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
  import ProfileStep1 from './create-profile-step-1.vue';
  import ProfileStep2 from './create-profile-step-2.vue';
  import ProfileStep3 from './create-profile-step-3.vue';
  import userService from "services/user-service";

  import { createNamespacedHelpers } from 'vuex';
  const { mapActions, mapState } = createNamespacedHelpers('profile');

  export default {
    props: {
      userId: {
        type: String,
        required: true
      },
      token: {
        type: String,
        required: true
      },
      isPatient: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        isTokenValid: true,
        steps: [
          {
            id: "password",
            component: ProfileStep1,
            active: true
          },
          {
            id: "address",
            component: ProfileStep2,
            active: true
          },
          {
            id: "agreement",
            component: ProfileStep3,
            active: true
          }
        ],
      };
    },

    computed: {
      ...mapState(["profile"]),
    },

    methods: {
      ...mapActions(["createPatientProfile", "createClientProfile"]),

      async next() {
        await this.$refs.stepper.next();

        if (this.$refs.stepper.finalStep)
          await this.createProfile();
      },
      
      async createProfile() {
        this.profile.isPatient ? await this.createPatientProfile() : await this.createClientProfile();

        this.$root.successToast("Profile created!");

        if (this.profile.isPatient) {
          await this.$auth.login(this.profile.email, this.profile.password, false, "/survey");
        } else {
          this.$router.push({ name: 'default' });
        }
      }
    },

    async created() {
      this.profile.isPatient = this.isPatient === 'true';
      this.profile.userId = this.userId;
      this.profile.token = this.token;
      this.isTokenValid = await userService.verifyEmailToken({ userId: this.userId, token: this.token });
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/styles/mixins';

  .page {
    @include retina('/png/stethoscope.png');
  }
</style>